import { Component, OnInit } from '@angular/core';
import { User } from '../../_models';
import { first } from 'rxjs/operators';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  users: User[] = [];

  constructor(private userService: UserService) {}

  ngOnInit() {
      this.userService.getAll().pipe(first()).subscribe((users: User[]) => { 
          this.users = users; 
      });
  }

}
